import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab, FormControl, FormGroup, FormControlLabel, InputLabel, LinearProgress, MenuItem, Select, Switch, TextField, Typography, } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import AddIcon from '@material-ui/icons/Add';
import { useUpdateChart } from '../../hooks';
import Lottie from './Lottie';
import checkmark from '../../animations/checkmark.json';
import errormark from '../../animations/errormark.json';
var ChartUpdater = function (_a) {
    var _b, _c;
    var columns = _a.columns, chartId = _a.chartId;
    var classes = useStyles();
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useUpdateChart(chartId), data = _e.data, processing = _e.processing, configuration = _e.configuration, currentConfiguration = _e.currentConfiguration, getChartConfiguration = _e.getChartConfiguration, updateChart = _e.updateChart, handleChartName = _e.handleChartName, handleDataset = _e.handleDataset, handleBreakdown = _e.handleBreakdown, newBreakdownError = _e.newBreakdownError;
    var _f = useState(false), finishAnimation = _f[0], setFinishAnimation = _f[1];
    var _g = useState(false), addBreakdown = _g[0], setAddBreakdown = _g[1];
    useEffect(function () {
        if (open && !processing)
            setFinishAnimation(true);
    }, [processing]);
    var datasets = (_b = configuration === null || configuration === void 0 ? void 0 : configuration.measures) === null || _b === void 0 ? void 0 : _b.map(function (dataset, i) { return (React.createElement(FormGroup, { row: true, className: classes.formGroup, key: i },
        React.createElement(Typography, { className: classes.datasetName },
            dataset.type,
            React.createElement("br", null),
            "(",
            dataset.label,
            ")"),
        React.createElement(Divider, { orientation: "vertical", flexItem: true }),
        React.createElement(TextField, { label: "Dataset Label", name: dataset.type + dataset.rowId, value: dataset.label, className: classes.datasetLabel, onChange: function (event) { return handleDataset(event, 'label'); } }),
        React.createElement(FormControl, { className: classes.positionSelect },
            React.createElement(InputLabel, null, "Position"),
            React.createElement(Select, { autoFocus: true, name: dataset.type + dataset.rowId, value: dataset.position, onChange: function (event) { return handleDataset(event, 'position'); } },
                React.createElement(MenuItem, { value: "RIGHT" }, "Right"),
                React.createElement(MenuItem, { value: "LEFT" }, "Left"))),
        React.createElement(FormControlLabel, { name: dataset.type + dataset.rowId, label: "Show as %", labelPlacement: "start", control: React.createElement(Switch, { value: dataset.rowId, checked: dataset.percentage, onChange: function (event) { return handleDataset(event, 'percentage'); }, color: "primary" }) }))); });
    var breakdowns = (React.createElement(React.Fragment, null, (_c = currentConfiguration === null || currentConfiguration === void 0 ? void 0 : currentConfiguration.breakdowns) === null || _c === void 0 ? void 0 :
        _c.map(function (breakdown, i) { return (React.createElement(FormGroup, { row: true, className: classes.formGroup, key: i },
            React.createElement(Typography, { className: classes.datasetName }, "Breakdown"),
            React.createElement(Divider, { orientation: "vertical", flexItem: true }),
            React.createElement(TextField, { label: "Breakdown Label", name: breakdown.breakdownId, defaultValue: breakdown.label, onChange: function (event) { return handleBreakdown(event, 'label'); } }),
            React.createElement(FormControl, { key: i },
                React.createElement(InputLabel, null, "Current breakdown"),
                React.createElement(Select, { autoFocus: true, name: breakdown.breakdownId, className: classes.breakdownSelect, defaultValue: breakdown.breakdownId, onChange: function (event) { return handleBreakdown(event, 'breakdownId'); } }, columns.map(function (column, j) { return (React.createElement(MenuItem, { key: j, value: column.id }, column.key)); }))))); }),
        addBreakdown ? (React.createElement(FormGroup, { row: true, className: classes.formGroup, key: "newBreakdown" },
            React.createElement(Typography, { className: classes.datasetName }, "Breakdown"),
            React.createElement(Divider, { orientation: "vertical", flexItem: true }),
            React.createElement(FormControl, { key: "newDimension", error: newBreakdownError },
                React.createElement(InputLabel, null, newBreakdownError ? 'Error: Duplicate!' : 'New breakdown'),
                React.createElement(Select, { autoFocus: true, name: 'new', className: classes.breakdownSelect, defaultValue: "", onChange: function (event) { return handleBreakdown(event, 'breakdownId'); } }, columns.map(function (column, j) { return (React.createElement(MenuItem, { key: j, value: column.id }, column.key)); }))))) : (React.createElement(Fab, { size: "small", color: "primary", "aria-label": "add", onClick: function () { return setAddBreakdown(true); } },
            React.createElement(AddIcon, null)))));
    var DialogSkeleton = (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open: open, onClose: function () { return setOpen(false); }, "aria-labelledby": "form-dialog-title" },
        React.createElement(DialogTitle, { id: "form-dialog-title" }, "Chart Settings"),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(Skeleton, { variant: "rect", width: 240, height: 60, className: classes.chartName }),
            React.createElement(FormGroup, { row: true, className: classes.formGroup },
                React.createElement(Typography, { className: classes.datasetName },
                    React.createElement(Skeleton, { variant: "rect", height: 60 })),
                React.createElement(Divider, { orientation: "vertical", flexItem: true }),
                React.createElement(Skeleton, { variant: "rect", width: 166, height: 60 }),
                React.createElement(Skeleton, { variant: "rect", width: 100, height: 60 }),
                React.createElement(FormControlLabel, { label: "Show as %", control: React.createElement(Switch, null) })),
            React.createElement(Skeleton, { variant: "circle", width: 30, height: 30 })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: "primary" },
                React.createElement(Skeleton, { variant: "text", width: 80 })))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", onClick: function () {
                getChartConfiguration();
                setOpen(true);
            } }, "Change Chart Setting"),
        currentConfiguration ? (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open: open, onClose: function () { return setOpen(false); }, "aria-labelledby": "form-dialog-title" },
            React.createElement(DialogTitle, { id: "form-dialog-title" }, "Chart Settings"),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(TextField, { className: classes.chartName, label: "This Chart Name", value: (configuration === null || configuration === void 0 ? void 0 : configuration.name) || '', onChange: handleChartName, variant: "outlined" }),
                datasets,
                breakdowns),
            React.createElement(DialogActions, null,
                finishAnimation && (React.createElement(Lottie, { data: data ? checkmark : errormark, width: 36, height: 36, onEnd: function () {
                        setOpen(false);
                        setFinishAnimation(false);
                    } })),
                React.createElement(Button, { color: "primary", disabled: newBreakdownError, onClick: function () {
                        updateChart();
                    } }, "Update")),
            processing && React.createElement(LinearProgress, null))) : (DialogSkeleton)));
};
var useStyles = makeStyles({
    button: {
        float: 'right',
    },
    chartName: {
        width: 240,
        marginBottom: 20,
    },
    formGroup: {
        marginBottom: 24,
        '& > *': {
            marginRight: 10,
        },
    },
    datasetName: {
        width: 100,
        textAlign: 'center',
    },
    datasetLabel: {
        width: 166,
    },
    positionSelect: {
        minWidth: 100,
    },
    breakdownSelect: {
        minWidth: 166,
    },
});
export default ChartUpdater;
